import { useMutation } from '@tanstack/react-query';
import { ISystemJob } from '../../extViewmodels';
import { useUserSession } from '../../models/hooks/appStateHooks';

export interface IExportTranscriptsRequest {
	userId: string;
	startDate: string; // ISO date string
	endDate: string; // ISO date string
}

export const useExportTranscriptsMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: any) => void;
	onSuccess?: (data: ISystemJob) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({ userId, startDate, endDate }: IExportTranscriptsRequest) => {
			return userSession.webServiceHelper.callAsync<ISystemJob>(
				`lead/users/${userId}/transcripts/export?startDate=${startDate}&endDate=${endDate}`,
				'POST'
			);
		},
		onError,
		onSuccess,
	});
};
